module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/7-129534637bd38d6a4c2ab4ceef031a32.svg";